import { fetchInfoPopups } from '@/services/api';

export default {
  namespaced: true,

  state: {
    infoPopups: {},
  },

  actions: {
    async fetch({ rootState, commit }) {
      const { data } = await fetchInfoPopups(rootState.environmentId);

      const infoPopups = data.info_popups.reduce(
        (accumulator, currentValue) => {
          accumulator[currentValue.key] = currentValue;
          return accumulator;
        },
        {}
      );

      commit('setInfoPopups', infoPopups);
    },
  },

  mutations: {
    setInfoPopups(state, infoPopups) {
      state.infoPopups = infoPopups;
    },
  },

  getters: {
    findByKey: (state) => (key) => {
      return state.infoPopups[key] || null;
    },
  },
};
